var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2527",
  transform: "translate(-647.923 -456)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 295",
  width: 24,
  height: 24,
  rx: 12,
  transform: "translate(647.923 456)",
  fill: "#5075f0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M664.165 466.254h-3.506l3.25-4.254h-4.093l-3.839 6.381h2.657l-1.986 5.5z",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/expressshiping.8378a682.svg";
export { SvgComponent as ReactComponent };